import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const WITHOUT_PILATES = ['Improvisar cada clase', 'Buscar ejercicios a último momento', 'Dudar cuando aparece un alumno con una limitación', 'Repetir siempre las mismas clases', 'Sentir que podrías enseñar mejor'];
const WITH_PILATES = ['Clases listas y bien estructuradas', 'Adaptaciones para cada necesidad', 'Herramientas para resolver cualquier situación', 'Más variedad y menos planificación', 'Enseñar con seguridad desde el primer minuto'];
interface ComparisonCardProps {
  title: string;
  items: string[];
  variant: 'without' | 'with';
}
export function PilatesComparison() {
  return <section className="w-full bg-beige-deep py-20" data-id="element-138" data-mp="k9vuw0kmhsbh">
      <div className="mx-auto max-w-3xl px-6" data-id="element-139" data-mp="kanh4ksbydp3">
        <div className="mx-auto max-w-2xl text-center" data-id="element-140" data-mp="3ixt2087f3r90">
          <p className="inline-flex items-center gap-2 rounded-full border border-brown-light/25 bg-white/70 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-brown-light" data-id="element-141" data-mp="3nxxjo1k2as0t">
            <span className="h-1.5 w-1.5 rounded-full bg-brown-light" data-id="element-142" data-mp="229xj9zy83wks" />
            LA REAL DIFERENCIA
          </p>
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-[1.05] text-brown-dark sm:text-5xl" data-id="element-143" data-mp="1si9wwdgix5q6">
            Con Pilates Resuelto vs Sin
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-brown-dark/70 sm:text-lg" data-id="element-144" data-mp="1ogg0ihdd2nvt">
            Cambiá la incertidumbre de improvisar por la tranquilidad de saber qué hacer.
          </p>
        </div>

        <div className="mt-10 space-y-5" data-id="element-145" data-mp="1ekv2eubey7rc">
          <ComparisonCard title="Sin Pilates Resuelto" items={WITHOUT_PILATES} variant="without" data-id="element-146" data-mp="19inpa1euklnf" />
          <ComparisonCard title="Con Pilates Resuelto" items={WITH_PILATES} variant="with" data-id="element-147" data-mp="15jwzyggmi8av" />
        </div>
      </div>
    </section>;
}
function ComparisonCard({
  title,
  items,
  variant
}: ComparisonCardProps) {
  const isWithPilates = variant === 'with';
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5
  }} className={`rounded-3xl p-7 sm:p-9 ${isWithPilates ? 'bg-brown-dark text-beige shadow-xl shadow-brown-dark/15' : 'border border-brown-light/20 bg-white text-brown-dark'}`} data-id="element-148" data-mp="x7d74w8dted3">
      <div className="flex items-center gap-3" data-id="element-149" data-mp="1kys8omsc3rna">
        <div className={`flex h-10 w-10 items-center justify-center rounded-full ${isWithPilates ? 'bg-brown-light text-beige' : 'bg-beige-deep text-brown-light'}`} data-id="element-150" data-mp="1kxh96z5x961z">
          {isWithPilates ? <CheckIcon className="h-5 w-5" strokeWidth={3} data-id="element-151" data-mp="1bzx5ljkl6xo7" /> : <XIcon className="h-5 w-5" strokeWidth={2.5} data-id="element-152" data-mp="3rnx5w6yuzno2" />}
        </div>
        <h3 className="font-serif text-2xl font-semibold sm:text-3xl" data-id="element-153" data-mp="jp1hdpibeaf">{title}</h3>
      </div>

      <ul className="mt-6 space-y-4" data-id="element-154" data-mp="3o5zmikd52c7q">
        {items.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed sm:text-base" data-id="element-155" data-mp="3k68r23co37wv">
            {isWithPilates ? <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brown-light" strokeWidth={2.75} data-id="element-156" data-mp="1zklydhmakr7" /> : <XIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brown-light" strokeWidth={2.25} data-id="element-157" data-mp="3t4axiyf66srj" />}
            <span className={isWithPilates ? 'text-beige/85' : 'text-brown-dark/75'} data-id="element-158" data-mp="35egkafqxv26r">{item}</span>
          </li>)}
      </ul>
    </motion.article>;
}